/*
 * @Descripttion: 选择人群组件
 * @Author: yang chenglin
 * @LastEditors: yang chenglin
 */
import React, { useState } from 'react';
import styles from './index.module.scss';
import Dialog_CrowdSelected_List from '@/pages/OrderSelection/components/Dialog_CrowdSelected_List';

/**
 * opType 固定为 'ALL'
 * @param changeData-把组件的值提交到父组件，改变父组件的值
 * @param tagItem-整个标签的信息
 */
const TagCrowd = ({
  tagItem = {}, changeData = (data) => {
  },
}, values = {}) => {
  const [openCrowdSelectedDiglog, setOpenCrowdSelectedDiglog] = useState(false); // 是否打开人群选择弹窗

  const showWdDialog = () => {
    setOpenCrowdSelectedDiglog(true);
  };

  /**
   * 选择完毕关闭弹窗
   */
  const confirm = (data, selected) => {
    setOpenCrowdSelectedDiglog(false);

    if (selected) {
      // 如果从子页面返回的是false，表明用户没有选s择人群，而是关闭了弹窗
      changeData({
        opValue: {
          label_id: tagItem?.id,
          extra_map: {
            source_audience_id: data.id,
            source_audience_name: data.name,
            source_audience_desc: data.intro
          }
        },
        opType: 'ALL'
      })
    }
  };


  return (
    <div>
      <div className={`${styles['tag-categories']} tag-width`}>
        <div
          className={styles['special-tag-wd']}
          onClick={showWdDialog}
        >重新选择<span>{tagItem?.opValue?.extra_map?.source_audience_id ? '已选择' : ''}</span>
        </div>
        <div>{tagItem?.opValue?.extra_map?.source_audience_name ?? ''}</div>
        <div style={{color:"#f33"}}
            className={`iconfont icon-icon4-30 ${styles['tag-error-select']}`}
          >请选择{tagItem.labelDescription}
        </div>
        {/* 人群选择弹窗 */}
        <Dialog_CrowdSelected_List
          visible={openCrowdSelectedDiglog}
          selected={(
            data: {
              id: string;
              name: string;
              intro: string;
              type: string;
              size: number;
              createDate: string;
            },
            selected: boolean,
          ) => {
            {
              confirm(data, selected);
            }
          }}
        />
      </div>
    </div>
  );
};
export default TagCrowd;
